export var spacePageView = function spacePageView(data) {
  return {
    barraLocalizacao: data.zipCodeBar ? 'verdadeiro' : 'falso',
    cepPreenchido: data.zipCode ? 'verdadeiro' : 'falso',
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    event: 'virtualPageview',
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'deslogado',
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: 'seu-espaco',
    screenName: 'seu-espaco'
  };
};